import { Button, Form, message, Input, Col, Row } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import statisticApis from 'api/statisticApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat } from 'helpers/dateTimeHelper';

export default function MessageStatisticsPage() {

  const [statistics, setStatistics] = useState([]);

  async function fetchMessagesInfo(params={}) {
    try {
      const res = await statisticApis.messages(params);
      setStatistics(res);
    } catch (error) {
      message.info(error.message);
    }
  }

  useEffect(() => {
    fetchMessagesInfo()
  }, []);

  
  
  return (
    <>
      <h1>Messages Statistics</h1>
      <pre>{JSON.stringify(statistics, null, 2)}</pre>
    </>
  );
}
